import React from 'react';
import { Close } from '@mui/icons-material';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  TextField,
} from '@mui/material';

interface IProps {
  defaultTitle: string;
  open: boolean;
  close: () => void;
  handleTitleUpdate: (title: string) => void;
}

export default function TitleUpdateDialog(props: IProps) {
  const { defaultTitle, open, close, handleTitleUpdate } = props;
  const [title, setTittle] = React.useState(defaultTitle);

  return (
    <Dialog open={open} maxWidth="xs" onClose={close}>
      <DialogTitle textAlign="center">名称の変更</DialogTitle>
      <Box position="absolute" top={0} right={0}>
        <IconButton onClick={close}>
          <Close />
        </IconButton>
      </Box>
      <DialogContent>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            m: 'auto',
            width: 'fit-content',
          }}
        >
          <TextField
            error={title === ''}
            required
            sx={{ width: 300 }}
            id="outlined-required"
            label="名称"
            onChange={(e) => setTittle(e.target.value)}
            defaultValue={title}
            helperText={title === '' ? '名称は必須です。' : ''}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Box
          sx={{
            display: 'flex',
            m: 'auto',
            width: 'fit-content',
            marginBottom: '20px',
          }}
        >
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 1, sm: 2, md: 4 }}
          >
            <Button color="inherit" variant="contained" onClick={close}>
              キャンセル
            </Button>
            <Button
              color="primary"
              variant="contained"
              onClick={() => handleTitleUpdate(title)}
            >
              変更
            </Button>
          </Stack>
        </Box>
      </DialogActions>
    </Dialog>
  );
}
